import { supabase } from './supabase';

// Inscription
export async function signUp(email, password, businessName) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: { business_name: businessName }
    }
  });
  return { data, error };
}

// Connexion
export async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  });
  return { data, error };
}

// Déconnexion
export async function signOut() {
  const { error } = await supabase.auth.signOut();
  return { error };
}

// Récupérer l'utilisateur connecté
export async function getCurrentUser() {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
}